import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { MODAL_TYPE_REGISTER } from '../../../services/modal/constants';
import { showModal } from '../../../services/modal/actions';
import LoginFormComponent from './LoginFormComponent';

import './LoginModalComponent.scss';

class LoginModalComponent extends React.Component {
    showRegisterModal = () => this.props.showModal(MODAL_TYPE_REGISTER);

    render() {
        const {
            currentPath = '/',
            redirection,
            notRegisteredText,
            registerText,
            LOG_IN,
            dynamicText
        } = this.props;
        return (
            <div className="modal-login-form">
                <h1>{LOG_IN}</h1>
                {dynamicText && <p>{dynamicText}</p>}
                <LoginFormComponent currentPath={redirection || currentPath} />
                <p className="register-link txtcenter">
                    {notRegisteredText}
                    <span className="fakelink" onClick={this.showRegisterModal}>
                        {registerText}
                    </span>
                </p>
            </div>
        );
    }
}

LoginModalComponent.propTypes = {
    i18n: PropTypes.object
};

const mapStateToProps = state => {
    return {
        LOG_IN: state.i18n.page.login.TITLE,
        notRegisteredText: state.i18n.feature.form.NOT_REGISTERED,
        registerText: state.i18n.page.register.BUTTON_REGISTER
    };
};

const mapDispatchToProps = {
    showModal
};

export default connect(mapStateToProps, mapDispatchToProps)(LoginModalComponent);



// WEBPACK FOOTER //
// ./src/components/authentication/login/LoginModalComponent.js